import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Button } from "reactstrap";

import PrintResume from "./Resume";

function PdfRender() {
  const componentRender = useRef();
  const handlePrint = useReactToPrint(
    {
    content: () => componentRender.current,
    documentTitle: "Resume",
  
    // onAfterPrint: () => alert('print Success')
  }

 
  );

  return (
    <>
       

      <div ref={componentRender}>
        <PrintResume />

        {/* <button onClick={handlePrint}>Print</button> */}
      </div>
      <Button
          style={{ marginLeft: "7.813rem" }}
          color="secondary"
          outline
          onClick={handlePrint}
        >
          Print
        </Button>
    </>
  );
}

export default PdfRender;
